<template>
  <div class="pagination">
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {reactive, toRefs} from 'vue'
import {pagination} from '../config/component.config'

export default {
  name: 'sr-pagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  setup(props, ctx) {
    // todo - data
    const state = reactive({
      pageSizes: pagination.pageSizes,
      layout: pagination.layout,
    })

    // todo - methods
    const scopedMethods = {
      handleSizeChange: async val => {
        await ctx.emit('update:currentPage', pagination.currentPage)
        await ctx.emit('update:pageSize', val)

        ctx.emit('fetchData')
      },
      handleCurrentChange: async val => {
        await ctx.emit('update:currentPage', val)

        ctx.emit('fetchData')
      },
    }

    return {
      ...toRefs(state),
      ...scopedMethods
    }
  }
}
</script>

<style scoped>
.pagination {
  padding-top: 10px;
}
</style>
